import axiosClient from "./axiosClient";
import dashboardMetricApi from "./dashboardMetricApi";

// Backend route: [Route("api/v1/dashboard/sessions")] → UserSessionsController
// axiosClient.baseURL already includes /api/v1, so we just append /dashboard/sessions.
const userSessionApi = {
  getAll: (params) => axiosClient.get("/dashboard/sessions", { params }),
  getRecentSessions: (params) => dashboardMetricApi.getSessions(params),
};

export default userSessionApi;